// import React from 'react'
// import {
//   Animated,
//   ViewStyle,
// } from 'react-native'
import wrapComponent from "../core/wrapComponent";
import { STYLE_WRAPPER_TYPE } from "../utils/constants"; // @ts-ignore

import SliderElement from '@react-native-community/slider'; // export type ChangeEvent =
//     | 'onSlidingComplete'
//     | 'onSlidingStart'
//     | 'onValueChange'
// type Dimensions = {height: number; width: number}
// export type SliderProps = {
//   style?: Record<string, any>;
//   animateTransitions?: boolean;
//   animationConfig?: {
//     spring?: any;// SpringAnimationConfig;
//     timing?: any;// TimingAnimationConfig;
//   };
//   animationType?: 'spring' | 'timing';
//   containerStyle?: ViewStyle;
//   debugTouchArea?: boolean;
//   disabled?: boolean;
//   maximumTrackTintColor?: string;
//   maximumValue?: number;
//   minimumTrackTintColor?: string;
//   minimumValue?: number;
//   onSlidingComplete?: (value: number | Array<number>) => void;
//   onSlidingStart?: (value: number | Array<number>) => void;
//   onValueChange?: (value: number | Array<number>) => void;
//   renderAboveThumbComponent?: (index: number) => React.ReactNode;
//   renderThumbComponent?: () => React.ReactNode;
//   step?: number;
//   thumbImage?: string | number | Array<string | number>;
//   thumbStyle?: ViewStyle;
//   thumbTintColor?: string;
//   thumbTouchSize?: Dimensions;
//   trackClickable?: boolean;
//   trackStyle?: ViewStyle;
//   value?: number | Array<number>;
// }
// export type SliderState = {
//   allMeasured: boolean;
//   containerSize: Dimensions;
//   thumbSize: Dimensions;
//   values: Array<Animated.Value>;
// }

export { SliderProps } from '@react-native-community/slider';
export default wrapComponent(SliderElement, {
  styleWrapper: STYLE_WRAPPER_TYPE.relativeSize
});